import React from 'react';
import {
  Box,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core';
import CustomScroll from 'react-custom-scroll';
import FsCategoryIconLoader from 'ui-elements/image-loaders/FsCategoryIconLoader';
import useTheme from '@material-ui/core/styles/useTheme';
import {
  Caption,
  StyledList,
  StyledListItem,
} from './CategoryList.style-elements';

export interface CategoryListItem {
  id: string;
  categoryName: string;
}

interface CategoryListProps {
  caption: string;
  categories: CategoryListItem[];
  onSelect: (id: string) => void;
  currentSelection: string | null;
}

const CategoryList: React.FC<CategoryListProps> = ({
  caption,
  categories,
  onSelect,
  currentSelection,
}) => {
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const boxHeight = isUpSm ? 230 : undefined;

  const handleClick = (id: string): void => {
    onSelect(id);
  };

  return (
    <Box width="100%">
      <Caption>{caption}</Caption>
      <Box display="flex" height={boxHeight} marginTop={1}>
        <CustomScroll flex="1">
          <StyledList component="nav">
            {categories.map(({ id, categoryName }) => (
              <StyledListItem
                button
                key={id}
                onClick={(): void => handleClick(id)}
                selected={currentSelection === id}
                data-test="category-single-item"
              >
                <ListItemIcon>
                  <FsCategoryIconLoader categoryName={categoryName} />
                </ListItemIcon>
                <ListItemText primary={categoryName} />
              </StyledListItem>
            ))}
          </StyledList>
        </CustomScroll>
      </Box>
    </Box>
  );
};

export default CategoryList;
